const API = {
  PAYMENT_REQUEST_INCLUDE_OLDER_RECORDS: 'payment/request?include_older_than_one_year=true',
  PAYMENT_REQUEST: 'payment/request',
  PAYMENT_REQUESTS_USER: `/payment/request/user/{userId}`,
  PAYMENT_REQUEST_BY_ID: `/payment/request/{id}`,
  STUDENT_PLAN: '/studentplan/{seniorUserId}',
  STAFFS: '/staff',
  LAUNCH_SCORM: 'launchscorm',
  UPDATE_E_COURSE_STATUS: 'update/course/status',
};

export default API;
